<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 14 23">
    <g clip-path="url(#clip0_7128_2120)">
      <mask id="path-1-inside-1_7128_2120" fill="white">
        <path
          d="M7 0.75C3.136 0.75 0 3.73667 0 7.41667C0 9.25667 0.77 10.9633 2.184 12.2433C2.31 12.35 2.436 12.4433 2.576 12.55L2.716 12.6567C2.968 12.8433 3.234 13.0033 3.5 13.15V22.7633L6.972 20.23L10.5 22.7633V13.15C10.766 13.0033 11.032 12.8433 11.284 12.6567L11.424 12.55C11.564 12.4567 11.69 12.3633 11.816 12.2433C13.23 10.9633 14 9.25667 14 7.41667C14 3.73667 10.864 0.75 7 0.75ZM9.1 20.07L6.958 18.5367L4.9 20.0433V14.4033C5.572 14.63 6.286 14.7367 7 14.7367C7.714 14.7367 8.428 14.6167 9.1 14.4033V20.07ZM10.85 11.27C10.766 11.3367 10.682 11.4033 10.584 11.47L10.416 11.59C8.4 13.11 5.6 13.0967 3.584 11.59L3.416 11.4567C3.332 11.39 3.234 11.3367 3.164 11.2567C2.03 10.23 1.414 8.87 1.414 7.40333C1.4 4.47 3.906 2.08333 7 2.08333C10.094 2.08333 12.6 4.47 12.6 7.41667C12.6 8.88333 11.984 10.2433 10.85 11.27ZM9.45 7.41667C9.45 8.71 8.358 9.75 7 9.75C5.642 9.75 4.55 8.71 4.55 7.41667C4.55 6.12333 5.642 5.08333 7 5.08333C8.358 5.08333 9.45 6.12333 9.45 7.41667Z"
        />
      </mask>
      <path
        d="M7 0.75C3.136 0.75 0 3.73667 0 7.41667C0 9.25667 0.77 10.9633 2.184 12.2433C2.31 12.35 2.436 12.4433 2.576 12.55L2.716 12.6567C2.968 12.8433 3.234 13.0033 3.5 13.15V22.7633L6.972 20.23L10.5 22.7633V13.15C10.766 13.0033 11.032 12.8433 11.284 12.6567L11.424 12.55C11.564 12.4567 11.69 12.3633 11.816 12.2433C13.23 10.9633 14 9.25667 14 7.41667C14 3.73667 10.864 0.75 7 0.75ZM9.1 20.07L6.958 18.5367L4.9 20.0433V14.4033C5.572 14.63 6.286 14.7367 7 14.7367C7.714 14.7367 8.428 14.6167 9.1 14.4033V20.07ZM10.85 11.27C10.766 11.3367 10.682 11.4033 10.584 11.47L10.416 11.59C8.4 13.11 5.6 13.0967 3.584 11.59L3.416 11.4567C3.332 11.39 3.234 11.3367 3.164 11.2567C2.03 10.23 1.414 8.87 1.414 7.40333C1.4 4.47 3.906 2.08333 7 2.08333C10.094 2.08333 12.6 4.47 12.6 7.41667C12.6 8.88333 11.984 10.2433 10.85 11.27ZM9.45 7.41667C9.45 8.71 8.358 9.75 7 9.75C5.642 9.75 4.55 8.71 4.55 7.41667C4.55 6.12333 5.642 5.08333 7 5.08333C8.358 5.08333 9.45 6.12333 9.45 7.41667Z"
        :class="colorClass"
        stroke="white"
        stroke-width="0.4"
        mask="url(#path-1-inside-1_7128_2120)"
      />
    </g>
    <defs>
      <clipPath id="clip0_7128_2120">
        <rect width="14" height="22" fill="white" transform="translate(0 0.75)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
